<script setup>
const route = useRoute();
const page = useGetPage({
  setSeoMeta: false,
});
</script>
<template>
  <div class="container">
    <UserInterfaceGenericPageHeader return-route="/" style="z-index: 4">
      <h1>{{ page?.PageName }}</h1>
    </UserInterfaceGenericPageHeader>
    <kentico-shadow
      v-if="!!route.params.contentType"
      :content="route.params.contentType"
    />
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 16px;
  font-weight: 700;
  margin-block-start: 0;
  margin-block-end: 0;
}
</style>
